import React, { useContext } from "react";
import { Navigate } from "react-router";
import { ConfigContext } from "../../../context/ConfigContext";
import { DealerAccountContext } from "../../../context/DealerAccountContext";
import { RBACAccessContext } from "../../../context/RBACAccessContext/RBACAccessContext";
import { UserContext } from "../../../context/UserContext/UserContext";
import { isAuthorizedForMultipleAccounts } from "../../../pages/preferences/utils";

function CorporateViewWrapper({ children }: { children: React.ReactNode }) {
  const { isCorporateViewEnabled } = useContext(RBACAccessContext);

  const user = useContext(UserContext);
  const { corporateManagerSetupIncomplete } = useContext(DealerAccountContext);
  const { ENABLE_MULTIPLE_ACCOUNTS, ENABLE_CORPORATE_VIEW_DPA_ROLE } =
    useContext(ConfigContext);
  if (
    isCorporateViewEnabled &&
    isAuthorizedForMultipleAccounts(
      user,
      ENABLE_MULTIPLE_ACCOUNTS,
      ENABLE_CORPORATE_VIEW_DPA_ROLE
    ) &&
    corporateManagerSetupIncomplete
  )
    return <Navigate to="/my-dashboard" />;

  return children;
}

export default CorporateViewWrapper;
